/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';

/**
 *
 * @export
 * @interface WebApiIntegrationsDtoFortnoxPrintTemplateDto
 */
export interface WebApiIntegrationsDtoFortnoxPrintTemplateDto {
    /**
     *
     * @type {string}
     * @memberof WebApiIntegrationsDtoFortnoxPrintTemplateDto
     */
    template?: string | null;
    /**
     *
     * @type {string}
     * @memberof WebApiIntegrationsDtoFortnoxPrintTemplateDto
     */
    name?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoFortnoxPrintTemplateDto interface.
 */
export function instanceOfWebApiIntegrationsDtoFortnoxPrintTemplateDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoFortnoxPrintTemplateDtoFromJSON(json: any): WebApiIntegrationsDtoFortnoxPrintTemplateDto {
    return WebApiIntegrationsDtoFortnoxPrintTemplateDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoFortnoxPrintTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoFortnoxPrintTemplateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'template': !exists(json, 'template') ? undefined : json['template'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function WebApiIntegrationsDtoFortnoxPrintTemplateDtoToJSON(value?: WebApiIntegrationsDtoFortnoxPrintTemplateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'template': value.template,
        'name': value.name,
    };
}
